import { eventsFlux, NodeId, useEditorSelector } from '@candulabs/craft';
import { useMemo } from 'react';

// typescript doesnt quite get it from the return type of `getEventsForNode`...
type NodeEvents = {
  hovered: boolean;
  selected: boolean;
  dragged: boolean;
};

export const useNodeEvents = (id: NodeId): NodeEvents => {
  const nodeEventsSelector = useMemo(() => eventsFlux.selectors.getEventsForNode(id), [id]);
  return useEditorSelector(nodeEventsSelector);
};
